<template>
  <div class="card mb-3">
    <div class="card-header bg-light">
      <h5 class="mb-0">Datos sobre la actuación</h5>
    </div>
    <div class="card-body">
      <div class="form-group">
        <label for="action_type">Tipo de actuación</label>
        <app-textarea-ai
          :value="localResume.action_type"
          @input="$emit('update:action_type', $event)"
          @blur="v.action_type && v.action_type.$touch()"
          :enable-ai="true"
          :max-chars="5000"
          :rows="3"
          placeholder="Describa el tipo de actuación"
          id="action_type"
          :textarea-class="{
            'form-control': true,
            'is-invalid': v.action_type && v.action_type.$error,
          }"
        ></app-textarea-ai>
        <div v-if="v.action_type && v.action_type.$error" class="invalid-feedback">
          <div v-if="!v.action_type.required">{{ errorMessages.required }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { errorMessages } from "@/helpers/validations/errorMessages";
import AppTextareaAi from "@/components/forms/AppTextareaAi.vue";

export default {
  name: "ActionTypeSection",
  components: {
    AppTextareaAi,
  },
  props: {
    localResume: {
      type: Object,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      errorMessages,
    };
  },
};
</script>
